var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _ellipse, _circle5, _circle6, _path5, _path6, _path7, _ellipse2, _path8, _path9, _ellipse3, _path0, _ellipse4, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeddyBear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M25 22h-.253c.16-.798.253-1.633.253-2.5c0-5.247-3.134-9.5-7-9.5s-7 4.253-7 9.5c0 .867.093 1.702.253 2.5H11c-2 3-1.502 8.056.122 9C18 35 14 29 18 29s0 6 6.878 2c1.624-.944 2.122-6 .122-9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M23.667 20.458c-.177-1.544.317-3.562.255-5.25C22.535 16.292 19.947 17 18 17s-4.51-.708-5.897-1.792c-.062 1.688.407 3.706.23 5.25c-.458 4 2.353 7.184 5.667 7.184s6.125-3.184 5.667-7.184z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M12.373 14s-5 1-6 7s3.419 6.581 5 5c2-2 0-4 0-4s1-5 1-8zm11.254 0s5 1 6 7s-3.419 6.581-5 5c-2-2 0-4 0-4s-1-5-1-8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0041E",
    d: "M13 13c-2 0-1 1-1 2s1 3 3 2c0 0-1 2-1 5c0 0 2 0 3 2c0 0 1-7 1-9s-4-2-5-2zm10 0c2 0 1 1 1 2s-1 3-3 2c0 0 1 2 1 5c0 0-2 0-3 2c0 0-1-7-1-9s4-2 5-2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#C1694F",
    cx: 11,
    cy: 4,
    r: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#662113",
    cx: 11,
    cy: 4,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#C1694F",
    cx: 25,
    cy: 4,
    r: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#662113",
    cx: 25,
    cy: 4,
    r: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C1694F",
    cx: 18,
    cy: 8.5,
    rx: 8,
    ry: 7.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#292F33",
    cx: 15,
    cy: 8,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#292F33",
    cx: 21,
    cy: 8,
    r: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99E82",
    d: "M18.058 9.563c-6.808 0-4.612 5.562-.147 5.562c4.464 0 6.955-5.562.147-5.562z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F33",
    d: "M16.737 11.065l.526.911a.851.851 0 0 0 1.474 0l.526-.911a.851.851 0 0 0-.737-1.277h-1.052a.851.851 0 0 0-.737 1.277z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#934035",
    d: "M11.265 27.002a.499.499 0 0 1-.269-.921a2.417 2.417 0 0 0 .997-2.022c-.023-.991-.933-1.641-.942-1.646a.507.507 0 0 1-.213-.368c-.205-2.36.65-4.709.687-4.809a.5.5 0 0 1 .938.346c-.008.021-.761 2.099-.644 4.165c.375.322 1.146 1.124 1.174 2.289c.044 1.91-1.398 2.851-1.459 2.89a.523.523 0 0 1-.269.076zm13.471 0a.5.5 0 0 1-.269-.078c-.062-.039-1.504-.979-1.46-2.89c.027-1.165.799-1.967 1.174-2.289c.118-2.072-.636-4.143-.644-4.164a.5.5 0 1 1 .938-.347c.037.099.893 2.448.688 4.809a.502.502 0 0 1-.215.369c-.008.005-.918.654-.94 1.646a2.416 2.416 0 0 0 .997 2.022a.5.5 0 0 1-.269.922zM24.665 22h.01h-.01z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-45.001 11.121 30.5)",
    fill: "#C1694F",
    cx: 11.122,
    cy: 30.5,
    rx: 4.5,
    ry: 5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99E82",
    d: "M13.349 33.227c-1.054 1.054-2.906.912-4.137-.318c-1.23-1.23-1.373-3.082-.318-4.137c1.054-1.054 2.906-.912 4.137.318c1.23 1.231 1.372 3.083.318 4.137z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99E82",
    d: "M12.889 32.768c-.781.781-2.206.623-3.182-.354c-.976-.976-1.135-2.401-.354-3.182c.781-.781 2.206-.623 3.182.354s1.135 2.401.354 3.182z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-45.001 24.878 30.5)",
    fill: "#C1694F",
    cx: 24.878,
    cy: 30.5,
    rx: 5,
    ry: 4.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99E82",
    d: "M22.651 33.227c1.054 1.054 2.906.912 4.137-.318c1.23-1.23 1.373-3.082.318-4.137c-1.054-1.054-2.906-.912-4.137.318c-1.23 1.231-1.372 3.083-.318 4.137z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-45.001 24.878 31)",
    fill: "#D99E82",
    cx: 24.878,
    cy: 31,
    rx: 2.5,
    ry: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#292F33",
    d: "M18.087 14.138c-1.28 0-2.249-.947-2.264-.961a.25.25 0 0 1 .353-.354c.075.074 1.849 1.797 3.647 0a.25.25 0 1 1 .354.354c-.721.721-1.445.961-2.09.961z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#934035",
    d: "M15.95 29.727a.5.5 0 0 1-.449-.28c-2.274-4.635-6.795-3.15-6.986-3.086a.5.5 0 0 1-.326-.946c.055-.02 5.543-1.845 8.21 3.592a.5.5 0 0 1-.449.72zm4.101 0a.499.499 0 0 1-.46-.695c2.255-5.301 8.141-3.641 8.198-3.623a.499.499 0 0 1 .339.619a.505.505 0 0 1-.619.341c-.207-.061-5.096-1.42-6.998 3.054a.502.502 0 0 1-.46.304z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeddyBear);
export default __webpack_public_path__ + "static/media/teddy-bear.ce353705211f55431deb0604d4d756c7.svg";
export { ForwardRef as ReactComponent };